<template>
  <section>
    <el-card data-qa="Content-Timeline-Card" v-loading="!lists">
      <div class="timeline-header" data-qa="Content-Timeline-Header" slot="header">
        <span data-qa="Content-TimelineHeader-Title">{{ $t('timelineComponentTitle') }}</span>
        <el-button
          @click="openTimelineModel"
          :data-qa="`Content-TimelineHeader-Button-ViewAll`"
          plain
          type="primary"
        >
          {{ $t('timelineButtonViewAllText') }}
        </el-button>
      </div>
      <timeline-log :log-list="lists" :fields="fields"></timeline-log>
    </el-card>
    <timeline-model :showEventFilter="showEventFilter" :fields="fields"></timeline-model>
  </section>
</template>

<script>
  import main from './Timeline.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './Timeline.scss'
</style>



// WEBPACK FOOTER //
// Timeline.vue?77befa24